import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs';
import { UserService } from '../../core/services/user/user.service';
import { SharedModule } from '../../shared/shared.module';
import { OkCancelModalComponent } from '../../ui-elements/generic-modal/ok-cancel-modal/ok-cancel-modal.component';
import { UserLeavesService } from '../services/user-leaves.service';

@Component({
  selector: 'app-on-leave',
  imports: [SharedModule],
  templateUrl: './on-leave.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './on-leave.component.scss',
})
export class OnLeaveComponent implements OnInit {
  private userLeavesService = inject(UserLeavesService);
  private userService = inject(UserService);
  private router = inject(Router);
  private modalService = inject(NgbModal);
  private translate = inject(TranslateService);
  protected activeModal = inject(NgbActiveModal);

  private cancelLeaveInProgress = false;

  ngOnInit() {
    if (!this.userService.isOnLeaveNow()) {
      this.router.navigate(['/']);
    }
  }

  onEndLeave() {
    if (this.cancelLeaveInProgress) {
      return;
    }

    this.cancelLeaveInProgress = true;

    this.translate
      .get(['END_LEAVE_MODAL.TITLE', 'END_LEAVE_MODAL.DESCRIPTION', 'END_LEAVE_MODAL.YES', 'END_LEAVE_MODAL.NO'])
      .subscribe((translations: { [key: string]: string }) => {
        const [headerText, bodyText, save, discard] = Object.values(translations);

        const modalRef = this.modalService.open(OkCancelModalComponent, {
          size: 'lg',
        });

        const componentInstance = modalRef.componentInstance as OkCancelModalComponent;
        componentInstance.closeable = true;
        componentInstance.buttonTexts = [discard, save];
        componentInstance.buttonClasses = 'w-25 text-nowrap px-0';

        componentInstance.headerContent = headerText;
        componentInstance.bodyContent = bodyText;

        modalRef.dismissed.subscribe(() => {
          this.cancelLeaveInProgress = false;
        });

        componentInstance.cancel.subscribe(() => {
          this.activeModal.dismiss();
          this.cancelLeaveInProgress = false;
        });

        componentInstance.ok.subscribe(() => {
          this.userLeavesService
            .cancelLeave()
            .pipe(switchMap(() => this.userService.reload()))
            .subscribe((user) => {
              this.cancelLeaveInProgress = false;
              this.activeModal.dismiss();
              this.router.navigate(['/']);
            });
        });
      });
  }
}
